const Admin = () => {
  window.location.href = process.env.REACT_APP_ADMIN_URL;
};

export default Admin;
